import { combineReducers } from 'redux';
import { cardAutoScrollReducer } from './auto-scroll/reducer';
import { checkboxSelectionModeReducer } from './checkbox-selection-mode/reducer';
import { fieldsReducer } from './fields/reducer';
import { filteredCardsReducer } from './filtered-cards/reducer';
import { focusedReducer } from './focused/reducer';
import { lastSelectedCardKeyReducer } from './last-selected-card-key/reducer';
import { listSelectionRelativeCardReducer } from './list-selection-relative-card/reducer';
import { richCardReducer } from './rich-card/reducer';
import { selectedReducer } from './selected/reducer';

export default combineReducers({
	richCard: richCardReducer,
	selected: selectedReducer,
	lastSelectedCardKey: lastSelectedCardKeyReducer,
	listSelectionRelativeCard: listSelectionRelativeCardReducer,
	focused: focusedReducer,
	filteredCards: filteredCardsReducer,
	fields: fieldsReducer,
	isCheckboxSelectionMode: checkboxSelectionModeReducer,
	autoScroll: cardAutoScrollReducer,
});
